import { DraftConfiguration, DraftState, SizePx } from '@/types';
import { convertSizePxToSizeMm } from '@/model/configuration/convertSize';
import { isDraftSpecialTextConfiguration } from '@/model/configuration/isDraftConfigurationType';
import { getConfiguration } from '@/model/draft/getConfiguration';

export const setSpecialFontSizeAction =
  ({ cid }: DraftConfiguration, scale: number, size: SizePx) =>
  (draft: DraftState) => {
    const configuration = getConfiguration(draft, cid);
    if (isDraftSpecialTextConfiguration(configuration)) {
      configuration.scale = scale;
      configuration.task.size = size;
      configuration.size = convertSizePxToSizeMm(size, configuration.printType);
    }
  };
